import { Col, Row } from "antd";
import { PageTitle } from "../../../../../styles/global/Pages.styled";
import { Text } from "../../../Atomics/Text";
import { useTranslation } from "react-i18next";
import useFetch from "../../../../../server/useFetch";
import { Widget } from "../../../Atomics/Widget";
import { NoData } from "../../../Atomics/NoData";
import { IconWrapper } from "@synergy/icons";

export const HomepageEnvironmentCharts = () => {
    const { t } = useTranslation();
    const { data: environmentData, refetch: refetchEnvironmentData, isFetching: environmentDataIsFetching, remove: removeEnvironmentData } = useFetch(
        `/nova_wallboards/getenviormentdata`, "environmentData",
        null, null, null, 'https://36lsp94v05.execute-api.eu-west-1.amazonaws.com/v3_0_01', 300000);

    return (
        <Row gutter={[16, 16]} index={4} id='Environment'>
            <Col span={24} id="environment">
                <PageTitle>
                    <Text $fontColor="coolgray-12" $fontSize="text_md" $weight="medium" $marginRight="s03">{t("Environment")}</Text>
                </PageTitle>
            </Col>
            <Col span={6}>
                <Widget
                    data={{
                        background: "transparent",
                        title: t("title.Incidents by priority"),
                        icon: 'Clipboard',
                        border: null,
                        background: 'white',
                        height: '100%',
                        activeShadow: true,
                        margin: "0 0 10px 0",
                    }}
                >
                    {environmentData?.events ?
                        getByPriorityWidget(environmentData?.events, t)
                        : <NoData />}
                </Widget>
            </Col>
            <Col span={18}>
                <Widget
                    data={{
                        background: "white",
                        title: t("UV Index"),
                        icon: null,
                        activeShadow: true,
                        charts: [
                            {
                                chartType: "bigNumberChart",
                                chartId: "bigNumberChartOne",
                                height: "111px",
                                isFetching: environmentDataIsFetching,
                                data: environmentData?.actualUVIndex
                                    ? {
                                        number: environmentData.actualUVIndex
                                    }
                                    : null,
                            },
                        ],
                    }}
                />
            </Col>
            <Col span={24} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Text $weight='light'>{t("title.Atmospheric Data")}</Text>
            </Col>
            <Col span={8}>
                <Widget
                    data={{
                        tooltip: t("title.Data from Sunday to Saturday"),
                        background: "white",
                        title: t("title.Temperature"),
                        icon: null,
                        activeShadow: true,
                        charts: [
                            {
                                chartType: "areaChartApex",
                                height: "200px",
                                isFetching: environmentDataIsFetching,
                                data: environmentData?.weekTemperature
                                    ? getAreaChartData(environmentData?.weekTemperature?.metrics, "ºC")
                                    : null,
                            },
                        ],
                    }}
                />
            </Col>
            <Col span={8}>
                <Widget
                    data={{
                        tooltip: t("title.Data from Sunday to Saturday"),
                        background: "white",
                        title: t("title.CO₂ Emissions"),
                        icon: null,
                        activeShadow: true,
                        charts: [
                            {
                                chartType: "areaChartApex",
                                height: "200px",
                                isFetching: environmentDataIsFetching,
                                data: environmentData?.weekCO2Emissions
                                    ? getAreaChartData(environmentData?.weekCO2Emissions?.metrics, "ppm")
                                    : null,
                            },
                        ],
                    }}
                />
            </Col>
            <Col span={8}>
                <Widget
                    data={{
                        tooltip: t("title.Data from Sunday to Saturday"),
                        background: "white",
                        title: t("title.Air Humidity"),
                        icon: null,
                        activeShadow: true,
                        charts: [
                            {
                                chartType: "areaChartApex",
                                height: "200px",
                                isFetching: environmentDataIsFetching,
                                data: environmentData?.weekHumidityLevel
                                    ? getAreaChartData(environmentData?.weekHumidityLevel?.metrics, "%")
                                    : null,
                            },
                        ],
                    }}
                />
            </Col>
            <Col span={24} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Text $weight='light'>{t("Noise")}</Text>
            </Col>
            <Col span={24}>
                <Widget
                    data={{
                        tooltip: t("title.Data from Sunday to Saturday"),
                        background: "white",
                        title: t("title.Average Sound Level"),
                        icon: null,
                        activeShadow: true,
                        charts: [
                            {
                                chartType: "areaChartApex",
                                height: "200px",
                                isFetching: environmentDataIsFetching,
                                data: environmentData?.weekSoundLevel
                                    ? getAreaChartData(environmentData?.weekSoundLevel?.metrics, "dB")
                                    : null,
                            },
                        ],
                    }}
                />
            </Col>
            <Col span={24} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Text $weight='light'>{t("title.Soil")}</Text>
            </Col>
            <Col span={8}>
                <Widget
                    data={{
                        tooltip: t("title.Data from Sunday to Saturday"),
                        background: "white",
                        title: t("title.Soil Temperature"),
                        icon: null,
                        activeShadow: true,
                        charts: [
                            {
                                chartType: "areaChartApex",
                                height: "200px",
                                isFetching: environmentDataIsFetching,
                                data: environmentData?.weekGroundTemperature
                                    ? getAreaChartData(environmentData?.weekGroundTemperature?.metrics)
                                    : null,
                            },
                        ],
                    }}
                />
            </Col>
            <Col span={8}>
                <Widget
                    data={{
                        tooltip: t("title.Data from Sunday to Saturday"),
                        background: "white",
                        title: t("title.Soil Electrical Conductivity"),
                        icon: null,
                        activeShadow: true,
                        charts: [
                            {
                                chartType: "areaChartApex",
                                height: "200px",
                                isFetching: environmentDataIsFetching,
                                data: environmentData?.weekGroundElectricalConductivity
                                    ? getAreaChartData(environmentData?.weekGroundElectricalConductivity?.metrics)
                                    : null,
                            },
                        ],
                    }}
                />
            </Col>
            <Col span={8}>
                <Widget
                    data={{
                        tooltip: t("title.Data from Sunday to Saturday"),
                        background: "white",
                        title: t("title.Soil Humidity"),
                        icon: null,
                        activeShadow: true,
                        charts: [
                            {
                                chartType: "areaChartApex",
                                height: "200px",
                                isFetching: environmentDataIsFetching,
                                data: environmentData?.weekGroundHumidity
                                    ? getAreaChartData(environmentData?.weekGroundHumidity?.metrics)
                                    : null,
                            },
                        ],
                    }}
                />
            </Col>
        </Row>
    )
};

const getByPriorityWidget = (data, t) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', height: '100%' }}>
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-evenly' }}>


                {[{ label: 'Red', count: data["red"] ?? 0 },
                { label: 'Orange', count: data["orange"] ?? 0 },
                { label: 'Yellow', count: data["yellow"] ?? 0 }].map((status, index) => (
                    <div key={index} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', width: '30%', marginBottom: '20px' }}>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <IconWrapper $bgColor={status.label} $bgsize="5px" />
                            <h1 style={{ margin: '0', marginLeft: '5px' }}>{status.count}</h1>
                        </div>
                        {/* <span>{t(status.label)}</span> */}
                    </div>
                ))}
            </div>
        </div>
    );
};

const getAreaChartData = (data, unit) => {
    const series = data.map((item) => {
        return {
            x: item.name,
            y: item.uv,
        }
    });

    return {
        series: [
            {
                name: "",
                data: series,
            }
        ],
        categories: null,
        markerSize: 3,
        unit: unit || "",
        yAxisLabel: unit || "",
        columnWidth: 20,
        colors: ["#66cbc8"],
        hideToolbar: true,
        hideLegend: true,
    }
};